import { styled } from '@mui/material/styles';

export const IntuitWrapper = styled('div')`
	//padding-top: 1rem;
	//padding-bottom: 1rem;
	//padding-left: 1rem;
	//padding-right: 1rem;
	background-color: #14324fcc;
	min-height: 100vh;
	min-width: 100vw;
`;

export const ActionWrapper = styled('div')`
	display: flex;
	flex-direction: row;
	justify-content: space-around;
`;

export const TrieWrapper = styled('div')`
	padding-top: 1rem;
	padding-bottom: 1rem;
`;
